import { ElementDiscoveryController } from '../../elements/discovery';
import { VdsEvent } from '../../events';
export class ManagedElementConnectEvent extends VdsEvent {
}
ManagedElementConnectEvent.TYPE = 'vds-noop';
export class ManagedElement {
    constructor(_host) {
        this._host = _host;
        this._discoveryController = new ElementDiscoveryController(_host, this._getScopedDiscoveryEvent().TYPE);
    }
    static get _ScopedDiscoveryEvent() {
        return ManagedElementConnectEvent;
    }
    _getScopedDiscoveryEvent() {
        const ctor = this.constructor;
        const ScopedDiscoveryEvent = ctor._ScopedDiscoveryEvent;
        return ScopedDiscoveryEvent;
    }
}
